module.exports = __webpack_public_path__ + "img/gmail.8ac3b5d4.png";